import { render, staticRenderFns } from "./ViewImageModal.vue?vue&type=template&id=17e27f23&lang=pug&"
import script from "./ViewImageModal.vue?vue&type=script&lang=ts&"
export * from "./ViewImageModal.vue?vue&type=script&lang=ts&"
import style0 from "./ViewImageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports